import { useState, useEffect } from "react";
import "../theme/Administracion.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import { authProvider } from "../context/authProvider";
import { UseAdmin, UseUser } from "../hooks";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { useNavigate, useLocation } from "react-router-dom";
import { VERSION_APP } from "../utilities";
import { fetchSecciones } from "../Api/fetchSecciones";
import { ModuleCard } from "../components/shared/ModuleCard";
import { ModuleHeader } from "../components/shared/ModuleHeader";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const ReportesPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [adminData, setAdminData] = useState(null);
  const { jobTitle } = UseUser();
  const { branchFiSucursalId, brandfiMarcaId, branchFiPaisId, rolId } = UseAdmin();

  useEffect(() => {
    getDataSeccion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchFiPaisId, brandfiMarcaId, jobTitle, branchFiSucursalId, rolId]);

  const getDataSeccion = () => {
    if (
      branchFiPaisId !== null &&
      branchFiSucursalId !== null &&
      brandfiMarcaId !== null &&
      jobTitle !== null &&
      rolId !== null
    ) {
      const onFailure = ({ error }) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
        setIsLoading(false);
      };
      const onSuccess = ({ data }) => {
        const extractedData = data.body.seccion.CHILD1.map((item) => ({
          FCJSONSECCION2: item.FCJSONSECCION2,
          FCLINKSECCION2: item.FCLINKSECCION2,
          FCSEGUNDASECCION: item.FCSEGUNDASECCION,
          FCURLIMAGEN2: item.FCURLIMAGEN2,
          FISEGUNDASECCIONID: item.FISEGUNDASECCIONID,
          FCSTACKSECCION2: item.FCSTACKSECCION2,
          FCCHIL2: item.CHILD2,
        }));

        const contieneAdmin = extractedData.some((item) => item.FCSEGUNDASECCION === "Reportes");

        if (contieneAdmin) {
          const soloAministracion = data.body.seccion.CHILD1.filter(
            (item) => item.FCSEGUNDASECCION === "Reportes"
          );
          setAdminData(soloAministracion[0].CHILD2);
        }
        setIsLoading(false);
      };

      fetchSecciones(
        branchFiPaisId,
        brandfiMarcaId,
        jobTitle,
        branchFiSucursalId,
        VERSION_APP,
        Number(rolId)
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const handleModuleClick = (item) => {
    const { FCJSONSECCION3, FCLINKSECCION3 } = item;

    if (FCJSONSECCION3 === "navigateToFuncionOnRouter") {
      navigate(`/${FCLINKSECCION3}`, {
        state: {
          dataRouter: state.dataRouter,
          selectedChild: item,
        },
      });
    }
  };

  const section = Array.isArray(state?.dataRouter)
    ? state.dataRouter[0]
    : state?.dataRouter || null;

  const caption = section?.FCSEGUNDASECCION ?? "Reportes";

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption={caption} />
                </div>
              </div>

              <div>
                <div>
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      <ModuleHeader
                        title="Reportes"
                        subtitle="Seleccione un módulo para continuar"
                      />

                      <div className="admin-grid-container">
                        {adminData && (
                          <div className="admin-grid">
                            {adminData.map((item) => (
                              <ModuleCard
                                key={item.FCKEY}
                                item={item}
                                onClick={() => handleModuleClick(item)}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
